import type { ReactElement, SubmitEvent } from "react";
import { Link } from "react-router";

import { FormSummary } from "../../forms/fields.js";
import { useApiForm } from "../../forms/use-api-form.js";

/**
 * 押すだけで確定する確認画面（利用者の削除・契約者の引き継ぎ）。
 *
 * <b>注意書きはひな型の平文</b>（HTML ではない）。改行は CSS で見せる。
 * 題名（タブ）は呼ぶ側が付ける（読み込み中から出すため）。
 */
export function ConfirmPage({ title, lead, confirmText, action, cancel, submit, dialog }: {
    readonly title: string;
    readonly lead: string;
    readonly confirmText: string;
    /** 確定を送る API。 */
    readonly action: string;
    /** キャンセルで戻る画面。 */
    readonly cancel: string;
    readonly submit: { readonly label: string; readonly className: string };
    /**
     * 送る前にブラウザの確認ダイアログで聞く文（契約者の引き継ぎ。解約と同じく、取り消しにくい操作）。
     * キャンセルなら何も送らない。無ければ聞かない。
     */
    readonly dialog?: string;
}): ReactElement {
    const form = useApiForm(action);
    const onSubmit = (event: SubmitEvent<HTMLFormElement>): void => {
        if (dialog !== undefined && !globalThis.confirm(dialog)) {
            event.preventDefault();
            return;
        }
        form.onSubmit(event);
    };

    return (
        <div className="page max-w-lg">
            <div className="panel">
                <h1 className="page-title">{title}</h1>
                <p className="page-lead">{lead}</p>

                <FormSummary messages={form.summary} />

                <div className="alert-warning mb-7 whitespace-pre-line">{confirmText}</div>

                <div className="flex gap-3">
                    <Link to={cancel} className="btn-secondary grow">キャンセル</Link>
                    <form method="post" className="grow" onSubmit={onSubmit}>
                        <button type="submit" className={`${submit.className} w-full`} disabled={form.busy}>
                            {submit.label}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
